var map = {
	"./Listening.gif": "d170",
	"./Listening_to_G.gif": "4ae4",
	"./Listening_to_mic.gif": "e92e",
	"./Listening_to_molecule.gif": "2bf6",
	"./Listening_to_molecule_thinking.gif": "0b5e",
	"./Listening_to_thinking.gif": "da1d",
	"./Listening_to_user_input.gif": "dab6",
	"./Mic.gif": "8b91",
	"./Mic_to_G.gif": "1ed2",
	"./Molecule.gif": "771c",
	"./Molecule_Thinking.gif": "067d",
	"./Molecule_to_G.gif": "54ce",
	"./Molecule_to_mic.gif": "eaa6",
	"./Molecule_to_thinking.gif": "03b4",
	"./Super_G.gif": "9cc7",
	"./Thinking.gif": "4d1b",
	"./Thinking_to_molecule_thinking.gif": "5444",
	"./User_input.gif": "0992",
	"./User_input_to_Mic.gif": "3811",
	"./User_input_to_Molecule.gif": "f22c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f04c";